import { render } from "./PartnerSettings.vue?vue&type=template&id=7f289072"
import script from "./PartnerSettings.vue?vue&type=script&lang=js"
export * from "./PartnerSettings.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__